<script>
// import ApiClient from '../utils/ApiClient'
import store from '../../store'

export default {
  data () {
    return {
      users: []
    }
  },
  isNotExistDuplicationIsumTuneInPlayList () {
    let isumCodeArray = []
    for (let i = 0; i < Object.keys(store.state.playlist_a).length; i++) {
      if (store.state.playlist_a[i] !== undefined && store.state.playlist_a[i].isum_code) {
        isumCodeArray.push(store.state.playlist_a[i].isum_code)
      }
    }
    for (let i = 0; i < Object.keys(store.state.playlist_b).length; i++) {
      if (store.state.playlist_b[i] !== undefined && store.state.playlist_b[i].isum_code) {
        isumCodeArray.push(store.state.playlist_b[i].isum_code)
      }
    }
    let duplicationIsumCode = isumCodeArray.filter(function (x, i, self) {
      return self.indexOf(x) === i && i !== self.lastIndexOf(x)
    })
    console.log(duplicationIsumCode.length)
    if (duplicationIsumCode.length === 0) {
      store.dispatch('updateIsNotExistDuplicationIsumTuneFlag', true)
    } else {
      store.dispatch('updateIsNotExistDuplicationIsumTuneFlag', false)
    }
  },
  /**
   * プレイリスト内に重複したISUM曲が存在しないかを確認
   * @param isumCode
   * @param playListType
   * @param playListIndex
   * @param callback
   */
  isNotExistDuplicationIsumTune: function (isumCode, playListType, playListIndex, callback) {
    let result = true
    isumCode = isumCode.toString()
    playListType = parseInt(playListType)
    playListIndex = parseInt(playListIndex)
    for (let i = 0; i < Object.keys(store.state.playlist_a).length; i++) {
      if (store.state.playlist_a[i] !== undefined) {
        if (store.state.playlist_a[i].isum_code === isumCode) {
          result = false
          if (parseInt(i) === playListIndex && playListType === 1) {
            // プレイリスト箇所を確認する（プレイリストに二つ以上になってしまわないかを確認）
            result = true
          }
        }
      }
    }
    for (let i = 0; i < Object.keys(store.state.playlist_b).length; i++) {
      if (store.state.playlist_b[i] !== undefined) {
        if (store.state.playlist_b[i].isum_code === isumCode) {
          result = false
          if (i === playListIndex && playListType === 2) {
            // プレイリスト箇所を確認する（プレイリストに二つ以上になってしまわないかを確認）
            result = true
          }
        }
      }
    }
    callback(result)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/IsumService.vue